import { render, staticRenderFns } from "./EditPasswordCard.vue?vue&type=template&id=1d1379c3"
import script from "./EditPasswordCard.vue?vue&type=script&lang=js"
export * from "./EditPasswordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports